import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'
import { Label as LabelPrimitive } from 'radix-ui'

/*
 * A field label (design board 07): 14/20 600, above its control, 4 apart.
 *
 * `secondary` is the smaller, muted label a compact control (a `Picker`, a
 * code textarea, a filter beside a heading) uses instead — one style, not a
 * hand-copied className at each call site.
 */
const labelVariants = cva(
  'group-data-[disabled=true]:text-foreground-disabled peer-disabled:text-foreground-disabled flex items-center gap-2 select-none group-data-[disabled=true]:pointer-events-none peer-disabled:cursor-not-allowed',
  {
    variants: {
      variant: {
        default: 'text-foreground text-sm leading-5 font-semibold',
        secondary: 'text-muted-foreground text-xs font-semibold',
      },
    },
    defaultVariants: { variant: 'default' },
  },
)

function Label({
  className,
  variant,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(labelVariants({ variant }), className)}
      {...props}
    />
  )
}

export { Label }
